var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('nav',{staticClass:"page-nav",class:{ active: _vm.isVisible, footerIsVisible: _vm.footerIsVisible },attrs:{"id":"side-nav"}},[_vm._t("side-nav-content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }